export type ChatAboutFeedbackDetail = {
  /** Fully localized message, built at the dispatch site (which has i18n). */
  message: string;
};

/** Dispatched now; AgentOverlayProvider subscribes and opens the tutor chat. */
export function requestChatAboutFeedback(detail: ChatAboutFeedbackDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ChatAboutFeedbackDetail>("convo:chat-about-feedback", {
      detail,
    }),
  );
}
